import CommandIdEnum from "../enums/CommandIdEnums";

// The icons of the commands started from the toolbar, shared by its buttons and the current-command panel
const COMMAND_ICONS: Partial<Record<CommandIdEnum, string>> = {
    [CommandIdEnum.BundleInspector]: "/icons/bundle-inspector.svg",
    [CommandIdEnum.DetachBundleElements]: "/icons/bundle-inspector.svg",   // Runs from within the Bundle Inspector
    [CommandIdEnum.AddLengthDimension]: "/icons/dimension-temp.png",
    [CommandIdEnum.AddTextAnnotation]: "/icons/note-tool.svg",
    [CommandIdEnum.AddAreaAnnotation]: "/icons/area-tool.svg",
    [CommandIdEnum.AddRectangleAnnotation]: "/icons/rectangle-tool.svg",
    [CommandIdEnum.AddCircleAnnotation]: "/icons/circle-tool.svg",
    [CommandIdEnum.AddChecklistItem]: "/icons/check.svg",
    [CommandIdEnum.RemoveFromDocument]: "/icons/bin-temp.png",
};

// Null for commands without a toolbar button, such as the move and edit sub-commands
export const getCommandIconPath = (commandId: CommandIdEnum): string | null => COMMAND_ICONS[commandId] ?? null;
